/*REACT*/
import { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import schema from "./schema";

import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { ColorX, Authority, ErrorX } from "static";
import { store } from "static";
import { AccessTime, CastForEducation, Close, SkipNext } from "@mui/icons-material";
import { DatumizoBase } from "Components/LabIZO/Datumizo/DatumizoProps.interface";
import { DATA_LINK, backendConnector } from "connectors";
const T2VATrainer = () => {
  useEffect(() => {
    Authority.Require("FAQTrainer");
  }, []);
  let dtizo: any = null;
  const MountDtizo = (callback: any) => {
    dtizo = callback;
  };

  const Learn = {
    onClick: (id: string, data: object) => {
      store.Ask("Learn", "Confirm Changes", async () => {
        await Learn.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Learn");
      const url = DATA_LINK.T2VATrainerLearn;
      try {
        const { Success, payload } = await backendConnector.post(url, data);
        if (Success === true) {
          Learn.onSuccess();
        } else {
          Learn.onFail(payload);
        }
      } catch (e) {
        Learn.onFail(e);
      }
    },
    onSuccess: () => {
      store.Alert("Learn", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot learn example: " + e.message;
      ErrorX.Handle({ ...e, message: msg });
      dtizo.Reload();
    },
  };

  const Pass = {
    onClick: (id: string, data: object) => {
      store.Ask("Pass", "Confirm Changes", async () => {
        await Pass.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Pass");
      const url = DATA_LINK.T2VATrainerPass;
      try {
        const { Success, payload } = await backendConnector.post(url, data);
        if (Success === true) {
          Pass.onSuccess();
        } else {
          Pass.onFail(payload.message);
        }
      } catch (e) {
        Pass.onFail(e);
      }
    },
    onSuccess: () => {
      store.Alert("Set to Pass", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot set example to pass: " + e.message;
      ErrorX.Handle({ ...e, message: msg });
      dtizo.Reload();
    },
  };

  const Pending = {
    onClick: (id: string, data: object) => {
      store.Ask("Discuss", "Confirm Changes", async () => {
        await Pending.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Pending");
      const url = DATA_LINK.T2VATrainerPending;
      try {
        const { Success, payload } = await backendConnector.post(url, data);

        if (Success === true) {
          Pending.onSuccess();
        } else {
          Pending.onFail(payload.message);
        }
      } catch (e) {
        Pending.onFail(e);
      }
    },
    onSuccess: () => {
      store.Alert("Set to Pending", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot set example to pending: " + e.message;
      ErrorX.Handle({ ...e, message: msg });
      dtizo.Reload();
    },
  };

  const Reject = {
    onClick: (id: string, data: object) => {
      store.Ask("Reject", "Confirm Changes", async () => {
        await Reject.onConfirm(id, data);
      });
    },
    onConfirm: async (id: string, data: object) => {
      console.log("Reject");
      const url = DATA_LINK.T2VATrainerReject;
      try {
        const { Success, payload } = await backendConnector.post(url, data);
        if (Success === true) {
          Reject.onSuccess();
        } else {
          Reject.onFail(payload.message);
        }
      } catch (e) {
        Reject.onFail(e);
      }
    },
    onSuccess: () => {
      store.Alert("Set to Rejected", "success");
      dtizo.Reload(true);
    },
    onFail: (e: any) => {
      const msg = "Cannot set example to reject: " + e.message;
      ErrorX.Handle({ ...e, message: msg });

      dtizo.Reload();
    },
  };

  const base: DatumizoBase = {
    title: "Generic Answers",
    exportDoc: "Generic_Answers",
    schema: schema,
    reqAuth: "FAQTrainer",

    tablizo: {
      columnsToolbar: true,
      filterToolbar: true,
      densityToolbar: true,
      exportToolbar: false,
      showSelector: true,
    },
    Connect: {
      DeleteBulk: DATA_LINK.T2VATrainerDeleteBulk,
      List: DATA_LINK.T2VATrainerList,
      schema: schema.Table,
    },

    operations: {
      Add: {
        title: "Add Answer",
        url: DATA_LINK.T2VATrainerAdd,
        success: "Answer Added Successfully",
        fail: "Answer Add Failed: ",
        schema: schema.Add,
        buttons: ["Clear", "Submit"],
        onSubmit: "Add",
      },
      Delete: {
        title: "Delete this entry?",
        content: "Caution: This is irrevertable.",
        url: DATA_LINK.T2VATrainerDelete,
        success: "Entry Deleted Successfully.",
        fail: "Entry Delete Failed: ",
        onSubmit: "Delete",
      },
      DeleteBulk: {
        title: (n: number) => "Delete these " + n + " entries?",
        content: "Caution: This is irrevertable.",
        url: DATA_LINK.T2VATrainerDeleteBulk,
        success: "Entries Deleted Successfully.",
        fail: "Entries Delete Failed: ",
        onSubmit: "DeleteBulk",
      },
      Edit: {
        title: "Edit Answer ",
        url: DATA_LINK.T2VATrainerEdit,
        success: "Answer Edited Successfully",
        fail: "Answer Edit Failed: ",
        schema: schema.Edit,
        buttons: ["Revert", "Submit"],
        onSubmit: "Edit",
      },
      Info: {
        title: "Training Entry",
        schema: schema.Info,
        readOnly: true,
      },
    },

    buttons: {
      inline: [
        { icon: <CastForEducation />, func: Learn, caption: "Submit to Learn" },
        { icon: <AccessTime />, func: Pending, caption: "Discuss" },
        { icon: <SkipNext />, func: Pass, caption: "Pass" },
        { icon: <Close />, func: Reject, caption: "Reject" },
      ],
      inlineOpposite: [{ icon: "delete", func: "Delete", caption: "Delete", reqFunc: "Delete" }],
      left: [],
      right: [{ icon: "deletebulk", func: "DeleteBulk", caption: (n: number) => "Delete (" + n + ")", reqFunc: "Delete", theme: "caution" }],
    },
  };
  const title = "FAQ Trainer";

  return (
    <VStack>
      <Box padding={1} width="100%">
        <Typography
          style={{
            textAlign: "left",
            width: "100%",
            fontSize: 25,
            color: ColorX.GetColorCSS("Primary"),
          }}
        >
          {title}
        </Typography>
      </Box>
      <Datumizo base={base} serverSidePagination={false} onMounted={MountDtizo} />
    </VStack>
  );
};

export default T2VATrainer;
